"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.roundCoord = exports.getFeatureCollection = exports.clipToBbox = exports.createPointData = exports.isPointInRectangle = exports.getLayerIcon = exports.findLayers = exports.getLayerVisibility = exports.findLayer = exports.VectorLayerExtended = exports.getLayerWrapper = exports.pointsToLayer = exports.pointsToFeatures = exports.geoJsonToLayer = exports.geoJsonToFeatures = exports.getDefaultControls = exports.getBaseMapLayers = void 0;
const baseMaps_1 = require("./baseMaps");
const projections_1 = require("./projections");
const Zoom_1 = __importDefault(require("ol/control/Zoom"));
const ZoomSlider_1 = __importDefault(require("ol/control/ZoomSlider"));
const ScaleLine_1 = __importDefault(require("ol/control/ScaleLine"));
const ZoomToExtent_1 = __importDefault(require("ol/control/ZoomToExtent"));
const Vector_1 = __importDefault(require("ol/source/Vector"));
const Vector_2 = __importDefault(require("ol/layer/Vector"));
const GeoJSON_1 = __importDefault(require("ol/format/GeoJSON"));
const Feature_1 = __importDefault(require("ol/Feature"));
const Point_1 = __importDefault(require("ol/geom/Point"));
const bbox_clip_1 = __importDefault(require("@turf/bbox-clip"));
const helpers_1 = require("@turf/helpers");
const getBaseMapLayers = (selectedBaseMap, layerFilter = _ => true) => {
    const getNewTileLayer = ({ id, label, isEsri, isWorldWide, source, esriServiceName }) => {
        return new baseMaps_1.TileLayerExtended({
            visible: selectedBaseMap === id,
            isEsri,
            id,
            label,
            isWorldWide,
            esriServiceName,
            layerType: 'baseMap',
            source
        });
    };
    return baseMaps_1.defaultBaseMaps
        .filter(layerFilter)
        .map(bm => getNewTileLayer(bm));
};
exports.getBaseMapLayers = getBaseMapLayers;
const getDefaultControls = (projection, controlFilter = (ctrl) => true) => {
    return [
        new Zoom_1.default(),
        new ZoomSlider_1.default(),
        new ScaleLine_1.default(),
        new ZoomToExtent_1.default({ extent: (0, projections_1.getViewParams)(projection.getCode()).extent }),
    ].filter(controlFilter);
};
exports.getDefaultControls = getDefaultControls;
function geoJsonToFeatures(geoJsonData, epsgCodeForData, projection) {
    return (new GeoJSON_1.default()).readFeatures(geoJsonData, {
        dataProjection: epsgCodeForData,
        featureProjection: projection
    });
}
exports.geoJsonToFeatures = geoJsonToFeatures;
function geoJsonToLayer(layer, epsgCodeForData, projection, extent) {
    const source = new Vector_1.default({
        features: geoJsonToFeatures(layer.data, epsgCodeForData, projection)
    });
    return sourceToLayer("geojson", source, layer, extent);
}
exports.geoJsonToLayer = geoJsonToLayer;
function pointsToFeatures(points) {
    return points.map(p => new Feature_1.default({
        ...p.attributes,
        geometry: new Point_1.default(p.coord, 'XY')
    }));
}
exports.pointsToFeatures = pointsToFeatures;
function pointsToLayer(layer, extent) {
    const source = new Vector_1.default({
        features: pointsToFeatures(layer.data)
    });
    return sourceToLayer("point", source, layer, extent);
}
exports.pointsToLayer = pointsToLayer;
function sourceToLayer(geoType, source, layer, extent) {
    const vectorLayer = new VectorLayerExtended({
        id: layer.id,
        geoType,
        label: layer.label,
        extent: extent,
        source,
        visible: layer.visible,
        layerType: layer.layerType,
        ...layer.options,
        style: layer.style
    });
    vectorLayer.setProperties(layer.layerProps);
    return vectorLayer;
}
function getLayerWrapper({ id, label, layerType, visible, geoType, data, style, zIndex, interactive }) {
    return {
        id,
        layerType,
        geoType,
        label,
        layerProps: { id },
        visible,
        data,
        style,
        options: { zIndex, interactive }
    };
}
exports.getLayerWrapper = getLayerWrapper;
class VectorLayerExtended extends Vector_2.default {
    constructor(props) {
        super(props);
    }
}
exports.VectorLayerExtended = VectorLayerExtended;
function findLayer(map, layerId) {
    return map.getLayers().getArray().find(l => l.get('id') === layerId);
}
exports.findLayer = findLayer;
function getLayerVisibility(map, layerId, defaultVal = true) {
    return findLayer(map, layerId)?.get('visible') ?? defaultVal;
}
exports.getLayerVisibility = getLayerVisibility;
function findLayers(map, layerFilter) {
    return map.getLayers().getArray().filter(layerFilter);
}
exports.findLayers = findLayers;
function getLayerIcon(layer) {
    const style = (layer.getStyle ? layer.getStyle() : undefined);
    const circleStyle = (style && style.getImage ? style.getImage() : undefined);
    return circleStyle && circleStyle.getImage ? circleStyle.getImage(1) : undefined;
}
exports.getLayerIcon = getLayerIcon;
function isPointInRectangle(rectangles, point) {
    return rectangles.some(rect => point[0] >= rect[0][0] && point[0] <= rect[2][0] && // x
        point[1] >= rect[0][1] && point[1] <= rect[2][1] // y
    );
}
exports.isPointInRectangle = isPointInRectangle;
const createPointData = (station) => {
    return {
        coord: station.point,
        attributes: getProps(station)
    };
};
exports.createPointData = createPointData;
const clipToBbox = (layer) => {
    const geoJson = layer.geoJson;
    if (geoJson.type === "GeometryCollection") {
        const originalCoords = geoJson.geometries.map(geom => geom.coordinates);
        const clippedGeometries = originalCoords
            .map((coords) => (0, bbox_clip_1.default)((0, helpers_1.polygon)(coords), [-180, 0, 180, 90]))
            .map((f) => f.geometry);
        geoJson.geometries = clippedGeometries;
    }
    return layer;
};
exports.clipToBbox = clipToBbox;
function getFeatureCollection(stations) {
    return {
        type: "FeatureCollection",
        features: stations.map(station => ({
            id: station.id,
            type: "Feature",
            geometry: station.geoJson,
            properties: getProps(station)
        }))
    };
}
exports.getFeatureCollection = getFeatureCollection;
const roundCoord = (srid, coord) => {
    if (coord === undefined)
        return;
    if (srid === "4326")
        return coord.map(d => +d.toFixed(5));
    return coord.map(d => Math.round(d));
};
exports.roundCoord = roundCoord;
const round = (num, decimals) => {
    if (num === undefined)
        return;
    return +num.toFixed(decimals);
};
exports.round = round;
function getProps(station) {
    return Object.keys(station).reduce((acc, key) => {
        const prop = key === 'geoJson'
            ? undefined
            : station[key];
        if (prop !== undefined && !Array.isArray(prop)) {
            acc[key] = prop;
        }
        return acc;
    }, {});
}
